import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
  

export const NavLink = styled(Link)`
  color: #FFF;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-family: 'Azeret Mono';
  &:hover {
    color: #d9bb8f  !important;
  }
  &.active {
    text-decoration:underline;
  }
  font-size: 25px;
  font-weight: 500;
  text-transform: uppercase;
  font-style: italic;
  @media (max-width: 768px) {
    font-size: 18px;
    padding: 0 0.5rem;
  }
  @media (max-width: 480px) {
    font-size: 16px;
    padding: 0 0.4rem;
  }
  @media (max-width: 380px) {
    font-size: 14px;
    padding: 0 0.3rem;
  }
`;


